const tg = window.Telegram.WebApp;

export function useTelegram() {

    return {
        auth_data: tg.initData,
        tg
    }
}